"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = require("../utils");
exports.InstanceChainMap = new utils_1.CompositeKeyWeakMap();
//# sourceMappingURL=common.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/_lodash-decorators@4.5.0@lodash-decorators/factory/common.js
// module id = R4Mj
// module chunks = 0 1 2 3 4 5 6 7 8